import { Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { NamedTenant } from 'api';
import { CardButtonsComponent } from 'common/card/buttons/card-buttons.component';
import { DialogComponent } from 'common/dialog/dialog.component';
import { DialogFooterDirective } from 'common/dialog/dialog-slots.directive';
import { ButtonDirective } from 'common/button/button.directive';

@Component({
  selector: 'comp-switch-tenant-dialog',
  imports: [
    MatDialogClose,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    TranslateModule,
    CardButtonsComponent,
    DialogComponent,
    DialogFooterDirective,
    ButtonDirective,
  ],
  templateUrl: './switch-tenant-dialog.component.html',
})
export class SwitchTenantDialogComponent {
  readonly data = inject<{ tenants: NamedTenant[]; currentTenant: string | null }>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<SwitchTenantDialogComponent>);

  protected readonly selectedTenantId = signal<string | null>(null);

  constructor() {
    this.selectedTenantId.set(this.data.currentTenant);
  }

  protected save() {
    const selectedTenant = this.data.tenants.find(
      (tenant) => tenant.tenantId === this.selectedTenantId(),
    );

    this.dialogRef.close(selectedTenant);
  }
}
